<template>
  <div id="summary">
    <div class="summary" :class="[$mq, {TA:isTestAchat}]">
      <div class="toggle" :class="$mq">
        <div v-if="!disableDataPanel" class="left-button-wrapper" @click="isSituation = true">
          <div class="left-button" :class="{ active: isSituation, TA:isTestAchat }">
            <SvgIcon icon="situation" class="button-icon"></SvgIcon>
          </div>
          <span class="text" v-if="$mq === 'desktop'">{{
            $t("Summary.personal-details.button")
          }}</span>
        </div>
        <div class="left-button-wrapper" @click="isSituation = false">
          <div class="left-button" :class="{ active: !isSituation, TA:isTestAchat }">
            <SvgIcon icon="cart-dual" class="button-icon"></SvgIcon>
          </div>
          <span class="text" v-if="$mq === 'desktop'">{{
            $t("Summary.cart.button")
          }}</span>
        </div>
      </div>
      <div v-if="isSituation">
        <PersonalDetailsPanel
          :key="updateSummary"
          @personalDetails="add(`personalDetails`)"
          :disablePersonalDetails="contain(`personalDetails`)"
          @coholder="add(`coholder`)"
          @deleteCoholder="deleteCoholder()"
          :disableCoholder="contain(`coholder`)"
        ></PersonalDetailsPanel>
      </div>
      <div v-else>
        <ContractPanel
          :key="updateSummary"
          @deliverydate="add(`deliveryDate`)"
          :disableDeliveryDate="contain(`deliveryDate`)"
        ></ContractPanel>
      </div>
    </div>
    <ValidationObserver v-if="!disableDataPanel" ref="observer" @submit.prevent="next()" slim>
      <transition-group enter-active-class="animated headShake">
        <MissingDetails
          v-if="(fromLead || isTestAchat) && !contain(`personalDetails`) && missingInfo"
          key="missingDetails"
        ></MissingDetails>
        <!-- <Sponsor v-if="fromLead && !hasSponsorAlreadyBeenShown" key="sponsor"></Sponsor> -->
        <component v-for="component in components" :key="component" :is="component" @close="remove(component)"></component>
      </transition-group>
    </ValidationObserver>
  </div>
</template>

<script>
import ContractPanel from "./Summary/Contract";
import PersonalDetailsPanel from "./Summary/PersonalDetails";
import MissingDetails from "./MissingDetails";
import PersonalDetails from "./PersonalDetails";
import DeliveryDate from "./DeliveryDate";
import Coholder from "./Coholder";
// import Sponsor from "./Sponsor";
import { mapGetters, mapState } from "vuex";
import subscription from "../../store/modules/subscription";

export default {
  data() {
    return {
      isSituation: true,
      personalDetails: false,
      deliveryDate: false,
      coholder: false,
      updateSummary: 0,
      missingInfo: false,
      tmpValue: null,
      components: []
    };
  },
  computed: {
    ...mapGetters("common", ["fromLead"]),
    ...mapGetters("subscription", ["isResidential", "hasSomePersonalDetails", "isTestAchat"]),
    ...mapState("subscription", [
      "civility",
      "phone",
      "mail",
      "birthDate",
      "vatNumber",
      "companyName",
      "legalForm",
      // "hasSponsorAlreadyBeenShown"
    ]),
  },
  props: {
    defaultScreen: {
      type: String,
      required: false,
      default: "Situation",
    },
    disableDataPanel: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    add(componentName) {
      this.components.unshift(componentName);
    },
    contain(componentName) {
      return this.components.indexOf(componentName) !== -1;
    },
    remove(componentName) {
      let index = this.components.indexOf(componentName);
      this.components.splice(index, 1);
      this.updateSummary++;

      if (componentName === "personalDetails") {
        if (!this.mail || !this.phone || (this.isResidential && !this.birthDate))
          this.missingInfo = true;
        else this.missingInfo = false;
      }
    },
    scrollToClass(screen) {
      let elementsInErrors = document.getElementById('test').getElementsByClassName(screen);
      //console.log(elementsInErrors)
      if (elementsInErrors && elementsInErrors.length) {
          elementsInErrors[0].scrollIntoView();
      }
    },
  },
  components: {
    ContractPanel,
    PersonalDetailsPanel,
    MissingDetails,
    PersonalDetails,
    DeliveryDate,
    Coholder,
    // Sponsor,
  },
  created() {
    this.isSituation = this.defaultScreen === "Situation";
    this.tmpValue = { ...this.value };

    if (!this.mail || !this.phone) this.missingInfo = true;
    if (this.isResidential && !this.birthDate) this.missingInfo = true;
    if (!this.civility) this.missingInfo = true;
    if (!this.isResidential && (!this.vatNumber || !this.companyName || !this.legalForm)) this.missingInfo = true;
  },
};
</script>


// WEBPACK FOOTER //
// src/views/components/Summary.vue